<sew-headline level="3">{{ 'SEARCH.MULTIPLE.TITLE' | translate }}</sew-headline>
<p>{{ 'SEARCH.MULTIPLE.TASK' | translate }}</p>
<p class="parts-count">
    {{ partsCount }}
    {{ partsCount === 1 ? ('SEARCH.MULTIPLE.ENTRY' | translate) : ('SEARCH.MULTIPLE.ENTRIES' | translate) }}
</p>
<sew-input>
    <label for="spare-part-numbers">{{ 'SEARCH.MULTIPLE.TEXTAREA_PLACEHOLDER' | translate }}...</label>
    <textarea
        type="text"
        id="spare-part-numbers"
        title="{{ 'SEARCH.MULTIPLE.TITLE' | translate }}"
        [(ngModel)]="searchValue"
        (ngModelChange)="partsCount = $event === '' ? 0 : splitSearchString($event).length"
    ></textarea>
</sew-input>
<div class="sew-dialog-button-group">
    <sew-button hierarchy="primary" website>
        <button (click)="search()">
            {{ 'SEARCH.MULTIPLE.SEARCH_BUTTON' | translate }}
        </button>
    </sew-button>
</div>
